export const ADMIN_ROLE_NAME = 'Administrátor';

export const LANG_KEY = 'preferred_lang';

// Hide on iOS app: Capacitor.getPlatform() === 'ios', visible on IOS: false
export const IOS_DEPLOY_HIDE = false; // Capacitor.getPlatform() === 'ios';

